import { call, put, takeLatest } from "redux-saga/effects";

import { getBurnSuccess, getBurnFailure } from "./Burn.actions";
import { TokenBurnService } from "./Burn.store";

function* getBurnSaga(args) {
  try {
    const burnService = new TokenBurnService();
    const { data, total } = yield call(burnService.fetchTokenBurns, args);
    const { token, dateRange } = args;
    yield put(getBurnSuccess(data, token, dateRange, total));
  } catch (error) {
    yield put(getBurnFailure(error));
  }
}

export function* burnSagas() {
  const GET_BURN = "GET_BURN";
  yield takeLatest(GET_BURN, getBurnSaga);
}
